export default "__VITE_ASSET__8ecDScZ3__"